module.exports = __webpack_public_path__ + "static/img/14000151.7768b376.png";